import CookieConsent, {CookieConsentElementError} from '@inova/cookie-consent';

function preventCookieConsentRefresh() {
    const form = document.querySelector('[data-inova-cookie-settings]').querySelector('form');
    const settingsButton = document.querySelector('[data-inova-cookie-trigger="show-settings"]');
    const cookieNoticeContainer = document.querySelector('[data-inova-cookie-notice-container]');

    if (settingsButton) {
        settingsButton.addEventListener('click', () => {
            cookieNoticeContainer.setAttribute('aria-hidden', true);
        });
    }

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        const body = new FormData(form);
        const url = form.getAttribute('action');
        const method = form.getAttribute('method');

        fetch(url, {
            method,
            body,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(async (response) => {
            if (cookieNoticeContainer) {
                cookieNoticeContainer.remove();
            }
            document.querySelector('[data-inova-cookie-settings]').setAttribute('aria-hidden', true);
            const consent = await response.json();
            window.dispatchEvent(new CustomEvent('consent-update', {detail: {consent}}));
        });
    });
}

function initCookieConsentToggle() {
    const cookieConsentButton = document.querySelector('[data-open-cookie-consent]');
    const cookieSettings = document.querySelector('[data-inova-cookie-settings]');

    if (cookieConsentButton) {
        cookieConsentButton.addEventListener('click', () => {
            if (document.querySelector('[data-inova-cookie-notice]')) {
                return;
            }
            cookieSettings.removeAttribute('aria-hidden');
            preventCookieConsentRefresh();

            (new CookieConsent(document)).showSettings().catch(error => {
                // Throw this error if it's not a CookieConsent error or when app is not in production.
                if (! error instanceof CookieConsentElementError || process.env.NODE_ENV !== 'production') {
                    throw error;
                }

                console.error(`${error.name}: ${error.message}`);
            });
        });
    }
}

export default function initCookieConsent() {
    if (document.querySelector('[data-inova-cookie-notice]') !== null) {
        const cookieConsent = new CookieConsent(document);
        preventCookieConsentRefresh();

        let timeout = 1000;
        const locale = document.querySelector('[data-inova-cookie-notice-container]').getAttribute('data-inova-locale');
        if (locale === 'nl_BE' || locale === 'fr_BE') {
            timeout = 0;
        }

        setTimeout(() => {
            cookieConsent.showNotice().catch((error) => {
                // Throw this error if it's not a CookieConsent error or when app is not in production.
                if (!(error instanceof CookieConsentElementError) || process.env.NODE_ENV !== 'production') {
                    throw error;
                }

                console.error(`${error.name}: ${error.message}`);
            });
        }, timeout);
    }
    initCookieConsentToggle();
}
